<div class="container bg-light d-md-flex align-items-center">
  <div class="card box1 shadow-sm p-md-5 p-md-5 p-4">
    <div class="d-flex flex-column">
      <div class="d-flex align-items-center justify-content-between text mb-4"> <span>
          <strong class="">Total</strong>
        </span>
        <span class="ps">{{amount | currency}}</span>
      </div>
      <div class="border-bottom mb-4"></div>
      <div class="d-flex flex-column mb-4">
        <span class="far fa-file-alt text"> <span class="ps">
            <strong class="ps-2">Session with:</strong>
          </span></span>
        <span class="ps">{{instructor.firstName}} {{instructor.lastName}}</span>
      </div>
      <div class="d-flex flex-column mb-5">
        <span class="far fa-calendar-alt text"><span class="ps">
            <strong class="ps-2">Session Date:</strong>
          </span></span>
        <span class="ps">{{bookingDate}}</span>
      </div>
      <div class="d-flex align-items-center justify-content-between text mt-5">
        <div class="d-flex flex-column text"> <span>
            <strong>Customer Support:</strong>
          </span> <span>online chat 24/7</span>
        </div>
        <div class="btn btn-primary rounded-circle"><span class="fas fa-comment-alt"></span></div>
      </div>
    </div>
  </div>
  <div class="card box2 shadow-sm">
    <div class="row">
      <div class="col-12">
        <div class="d-flex flex-column p-md-5">
          <app-countdown-timer (countdownEnded)="countDownEnded($event)" [resetTimer]="resetTimer">
          </app-countdown-timer>
          <h3>Payment


          </h3>
        </div>
      </div>
    </div>
    <form ngxStripeCardGroup [elementsOptions]="elementsOptions" [formGroup]="stripeForm">
      <div class="row">
        <div class="col-12">
          <div class="d-flex flex-column px-md-5 px-4 mb-4">
            <span>Credit Card</span>
            <ngx-stripe-card-number [options]="cardOptions"></ngx-stripe-card-number>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex flex-column ps-md-5 px-md-0 px-4 mb-4">
            <span>Expiration<span class="ps-1">Date</span></span>
            <div class="inputWithIcon">
              <ngx-stripe-card-expiry [options]="cardOptions"></ngx-stripe-card-expiry>
              <span class="fas fa-calendar-alt"></span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex flex-column pe-md-5 px-md-0 px-4 mb-4">
            <span>Code CVV</span>
            <div class="inputWithIcon">
              <ngx-stripe-card-cvc [options]="cardOptions"></ngx-stripe-card-cvc>
              <span class="fas fa-lock"></span>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="d-flex flex-column px-md-5 px-4 mb-4">
            <span>Name</span>
            <div class="inputWithIcon"> <input formControlName="name" class="form-control text-uppercase" type="text"
                placeholder="Enter name">
              <span class="far fa-user"></span>
            </div>
          </div>
        </div>
        <div class="col-12 px-md-5 px-4 mt-3">
          <div class="btn btn-primary w-100 bg-dol-green" [ngClass]="{'formSubmitted':'disabled'}" (click)="pay()">Pay ${{amount}}</div>
        </div>
      </div>
    </form>
  </div>


</div>
